import { render } from "./DiesAcademicus.vue?vue&type=template&id=4c3b5e4c&scoped=true&ts=true"
import script from "./DiesAcademicus.vue?vue&type=script&lang=ts"
export * from "./DiesAcademicus.vue?vue&type=script&lang=ts"

import "./DiesAcademicus.vue?vue&type=style&index=0&id=4c3b5e4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c3b5e4c"]])

export default __exports__